/**
 * Parses a Panel. It adds no fields beyond Control: the base Control parser
 * collects its `theme_override_styles/panel` StyleBox.
 */
import { parseControl } from '../control/parser';
export function parsePanel(heading, properties) {
    return parseControl(heading, properties);
}
//# sourceMappingURL=parser.js.map